import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import CreatorPortal from "./pages/actors/CreatorPortal";
import "./index.css";
import "./services/firebase/init"; // 初始化 Firebase
import "./utils/getAuthToken"; // 在開發環境中暴露 getAuthToken 到 window

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {window.location.pathname.replace(/\/$/, "") === "/creator" ? <CreatorPortal /> : <App />}
  </React.StrictMode>
);
